import React from 'react';
// import {Link} from "react-router-dom";
import Svgs from '../Common/Svgs';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList } from 'recharts';
// import {Api} from '../Common/rest-api/api-exports';
import { getStatistics } from './epics-statistics';
// import * as _ from "ramda";
import SingleStatistic from './components/Single-statistic';
import { FormRow } from '../Common/form/formElements';
import { CompanySelectV2 } from '../Common/form/Elements-export';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
import { UserRole } from '../Common/UserRole';

import { cloneObject } from "../Common/Helpers";

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

const header = [
    { name: strings.Pharmacy, value: 'Pharmacy' },
    {},
    { name: strings.Pending_Orders, value: 'PendingOrders' },
    {},
    { name: strings.Accepted_Orders, value: 'AcceptedOrders' },
    {},
    { name: strings.Ready_Orders, value: 'ReadyOrders' },
    {},
    { name: strings.Canceled_Orders, value: 'CanceledOrders' },
    {},
    { name: strings.All_Orders, value: 'AllOrders' },
    {},
    { name: strings.Response_Time, value: 'ResponseTime' }
];

class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderBy: 'Pharmacy',
            orderDirection: 'asc',
            page: 0,
            limit: 30,
            chartWidth: 600,
            statistics: [],
            loader: true,
            chart: [
                {
                    show: true,
                    name: strings.Active_Orders,
                    key: 'activeOrdersCount',
                    color: '#ffab52'
                },
                {
                    show: true,
                    name: strings.Canceled_Orders,
                    key: 'cancelledOrdersCount',
                    color: '#f50404'
                },
                {
                    show: true,
                    name: strings.Closed_Orders,
                    key: 'closedOrdersCount',
                    color: '#2c76b5'
                },
                {
                    show: true,
                    name: strings.Pending_Orders,
                    key: 'pendingOrdersCount',
                    color: '#858585'
                },
                {
                    show: true,
                    name: strings.Ready_Orders,
                    key: 'readyOrdersCount',
                    color: '#2fff00'
                }
            ]
        };
    }

    componentDidMount() {
        this.updateChartDimensions();
        window.addEventListener('resize', this.updateChartDimensions);
        if (this.props.currentUser.role !== UserRole.ADMIN) {
            if (typeof this.props.currentUser.company !== 'undefined') {
                getStatistics(this.props.currentUser.company.id)
                    .then(response => {
                        this.setState({
                            statistics: response
                            // loader: false
                        });
                    })
                    .catch(error => {});
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateChartDimensions);
    }

    setCompany = company => {
        getStatistics(company)
            .then(response => {
                this.setState({
                    statistics: response,
                    loader: false
                });
            })
            .catch(error => {});
    };

    handleChartData = e => {
        const key = e.target.attributes.getNamedItem('name').value;
        const index = this.state.chart.findIndex(obj => {
            return obj.key === key;
        });
        let chartValue = cloneObject(this.state.chart);
        chartValue[index].show = !chartValue[index].show;
        this.setState({...this.state, chart: chartValue });
    };

    generateFilter = () => {
        return (
            <div className="row">
                <div className="col-12 formInput">
                    <label className="pt-0">{strings.Filter_by_status}</label>
                </div>

                {this.state.chart.map(obj => {
                    return (
                        <div className="col" key={obj.key}>
                            <label>
                                <input name={obj.key} type="checkbox" checked={obj.show} onChange={this.handleChartData} /> {obj.name}
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    };

    generateChart = () => {
        return (
            <div className="row">
                <div className="col qf-mb-30">
                    <div className="d-block" ref={chartHolder => (this.chartHolder = chartHolder)}>
                        <BarChart
                            width={this.state.chartWidth}
                            height={300}
                            data={this.state.statistics}
                            margin={{ top: 5, right: 45, left: 0, bottom: 5 }}
                            maxBarSize={25}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tickCount={this.state.statistics.length} />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            {this.state.chart.map(obj => {
                                if (obj.show) {
                                    return (
                                        <Bar key={obj.key} dataKey={obj.key} name={obj.name} fill={obj.color}>
                                            <LabelList dataKey={obj.key} position="top" />
                                        </Bar>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </BarChart>
                    </div>
                </div>
            </div>
        );
    };

    updateChartDimensions = () => {
        this.setState({
            chartWidth: this.chartHolder.offsetWidth
        });
    };

    onLimitChange = event => {
        this.setState({
            limit: event.target.value,
            page: 0
        });
    };

    generateTableHead = () => {
        let className = 'fa ';
        if (this.state.orderDirection === 'asc') {
            className += 'fa-angle-down';
        } else {
            className += 'fa-angle-up';
        }

        return (
            <thead>
                <tr>
                    {header.map((value, index) => {
                        if (value.name !== undefined) {
                            return (
                                <td key={index}>
                                    <div>
                                        {value.name}
                                        {this.state.orderBy === value.value ? (
                                            <i className={className} />
                                        ) : (
                                            <i className={'qf-invisible ' + className} />
                                        )}
                                    </div>
                                </td>
                            );
                        } else {
                            return <td key={index} />;
                        }
                    })}
                </tr>
            </thead>
        );
    };

    generateTableBody = () => {
        return (
            <tbody>
                {this.state.statistics.map(statistic => {
                    return <SingleStatistic key={statistic.id} data={statistic} />;
                })}
            </tbody>
        );
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.statistics}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        {this.props.currentUser.role === UserRole.ADMIN ? (
                            <FormRow>
                                <div className="col-9 mb-4">
                                    <h2 className="qf-page-title pb-0">
                                        <i className="fa fa-info-circle mr-2" />
                                        {strings.Statistics}
                                    </h2>
                                    <div className="qf-align-bottom">
                                        <hr className="qf-divider-line mb-0" />
                                    </div>
                                </div>
                                <CompanySelectV2
                                    role={this.props.currentUser.role}
                                    disabled={this.state.loader}
                                    label={`* ${strings.Company}`}
                                    handler={this.setCompany}
                                    name="company"
                                    extraClasses="col-3 mb-4 pt-3"
                                />
                            </FormRow>
                        ) : (
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="qf-page-title">
                                            <i className="fa fa-info-circle mr-2" />
                                            {strings.Statistics}
                                        </h2>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <hr className="qf-divider-line" />
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.generateFilter()}
                        {this.generateChart()}
                        <div className="row">
                            <div className="col-12">
                                <table className="qf-table qf-mb-30 qf-statistics-table">
                                    {this.generateTableHead()}
                                    {this.generateTableBody()}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/customModules/Statistics/component-list-statistics.js